import { apiRequestWrapped } from "./queryClient";
import { extractApiData, extractPagedApiData, ApiResponseWrapper } from "@/types/api";

// Generic helper for single item API calls
export async function fetchApiData<T>(method: string, url: string, data?: unknown): Promise<T> {
  const response = await apiRequestWrapped<T>(method, url, data);
  const result = extractApiData(response);
  
  if (!result) {
    throw new Error('Invalid API response: no data received');
  }
  
  return result;
}

// Generic helper for paginated API calls  
export async function fetchPagedApiData<T>(method: string, url: string, data?: unknown) {
  const response = await apiRequestWrapped<T>(method, url, data);
  const result = extractPagedApiData(response);
  
  if (!result) {
    throw new Error('Invalid API response: no paginated data received');
  }
  
  return result;
}

// Helper to get full response wrapper when needed (for accessing metadata)
export async function fetchApiResponse<T>(method: string, url: string, data?: unknown): Promise<ApiResponseWrapper<T>> {
  return await apiRequestWrapped<T>(method, url, data);
}

// Standardized error enhancement for React Query
export function enhanceApiError(error: any): Error {
  if (error.fullResponse) {
    // Attach API-specific error details
    error.apiCode = error.errorCode;
    error.apiDetails = error.errorDetails;
    error.httpStatus = error.status;
  }
  return error;
}